
import React, { lazy, useEffect, useState } from 'react'

import audioo from "../../../Assest/winning-218995.mp3"

const PercentageAdd = ({ mat, ques, row, ans, storfl, ch,ch1, last }) => {
    const [showFlash, setShowFlash] = useState(false);
    const [crtAnd, setCrtAnd] = useState([]);
    const [huray, setHuray] = useState(1);
    const [m, setM] = useState(0);
    let TotalCorrectAns = 0;
    let Pop_up = 0
    let TotalQuestion = 0
    let perCentage = 0
    const [display, setdisplay] = useState(1)
    const anskey = []
    const Userans = []
    let checkLast=0
    let len=0
    const matArg = []
    let temp = 0;
    // let total;
    let temp2;
    if(last){
        if(ch=="a"){
            for (let i = 0; i < ques; i++) {
                for(let j=0;j<row;j++){
                    temp=temp+mat[i][j]
                }
                anskey.push(temp)
                temp =0;
                if(anskey[i] == ans[i]){
                    TotalCorrectAns++;
                }
            }
            TotalQuestion = ques
        }


        if(ch == "m" && last && ans){
            temp =1;
            if(ques == 500){
                TotalQuestion = ans.length
            }else{
                TotalQuestion = ques
            }
            for(let i=0;i<TotalQuestion;i++){
                temp = mat[i][0] * mat[i][1]
                anskey.push(temp)
                temp=1
                if(anskey[i] == ans[i]){
                    TotalCorrectAns++;
                }
            } 
        }

        if(ch1=="Dr" && ch=='d'){
            if(ques==500){
                TotalQuestion = ans.length
            }else{
                TotalQuestion = ques
            }
            for(let i=0;i<TotalQuestion;i++){
                temp = mat[i][0] % mat[i][1]
                anskey.push(temp)
                temp=1
                if(anskey[i] == ans[i]){
                    TotalCorrectAns++;
                }
            } 
        }
        if(ch1=="Dn" && ch=='d'){
            if(ques==500 || ques == 250){
                TotalQuestion = ans.length
            }else{
                TotalQuestion = ques
            }
            for(let i=0;i<TotalQuestion;i++){
                temp = mat[i][0] / mat[i][1]
                anskey.push(temp)
                temp=1
                if(anskey[i] == ans[i]){
                    TotalCorrectAns++;
                }
            } 
        }


        if(TotalCorrectAns ){
            Pop_up = ((TotalCorrectAns / TotalQuestion) * 100).toFixed(2)
            if(Pop_up==100 && showFlash==false && huray==1 ){
                setShowFlash(true)
                var audio = new Audio(audioo)
                audio.play()
                setTimeout(fireWork,5000);

            }
        }
    }

    function fireWork(){
        setShowFlash(false)
        setHuray(0)
    }


    return (
        <div className='result-report'>
            <div className='resultDisplay'>
                {showFlash && <div className='flash-blast'></div>}
                <div className='mark'>
                    {TotalCorrectAns}/{TotalQuestion}
                </div>
                {/* <h1>HAPPY NEW YEAR</h1> */}
                <div className={showFlash ? "fireworks" : ""}>
                    <div class="firework">
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                    </div>
                    <div class="firework" >
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                    </div>
                    <div class="firework">
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                    </div>
                    <div class="firework" >
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                    </div>
                    <div class="firework">
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                    </div>
                    <div class="firework" >
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark silver"></div>
                        </div>
                    </div>
                    <div class="firework">
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                        <div class="explosion">
                            <div class="spark gold"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {/* {perCentage} */}
                <p>Total Number of Questios: <span>{TotalQuestion}</span></p>
                <p>Mark Scored <span>{TotalCorrectAns}</span></p>
                <p>Percentage <span>{Pop_up}</span></p>
            </div>
        </div>
    )
}
export default PercentageAdd